import AlertDescriptionSampleLink from "../AlertDescriptionSampleLink";
import { AlertDescriptionMultiAnalysisProps } from "../../@types";

const AlertDescriptionCloudSandbox = ({
  type,
  data,
  linksReloadDocument,
  onLinkClick
}: AlertDescriptionMultiAnalysisProps) => {
  const typeString = type.split("_").pop();
  return (
    <>
      RL Cloud Sandbox Analysis{" "}
      <AlertDescriptionSampleLink
        data={data}
        linksReloadDocument={linksReloadDocument}
        onLinkClick={onLinkClick}
      />{" "}
      has {typeString}.
    </>
  );
};

export default AlertDescriptionCloudSandbox;
